module.exports = __webpack_public_path__ + "img/logo.b35ae12f.svg";